import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CONSTANTS } from '../../../../../Constants/Constants';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonDataService } from '../../../../../services/common-data.service';
import { RequiredFieldsErrorComponent } from '../required-fields-error/required-fields-error.component';
import { SapSubmittalFailureComponent } from '../sap-submittal-failure/sap-submittal-failure.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-sap-submittal-required-field-dialog',
  templateUrl: './sap-submittal-required-field-dialog.component.html',
  styleUrl: './sap-submittal-required-field-dialog.component.scss',
  imports :[
    MatDialogModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class SapSubmittalRequiredFieldDialogComponent implements OnInit {
  private salesPersonName= CONSTANTS.EMPTY_STRING;
  private salesPersonEmail= CONSTANTS.EMPTY_STRING;

  requiredFieldForm: FormGroup<{
    name: FormControl<string>;
    email: FormControl<string>;
  }> = new FormGroup({
    name: new FormControl(CONSTANTS.EMPTY_STRING, [Validators.required]),
    email: new FormControl(CONSTANTS.EMPTY_STRING, [Validators.required, Validators.email])
  });

  constructor(
    private readonly dialogRef: MatDialogRef<SapSubmittalRequiredFieldDialogComponent>,
    private readonly commonDataService: CommonDataService,
    private readonly dialog: MatDialog 
  ) {}

  ngOnInit(): void {
    const prefs = this.commonDataService.getPreferenceData()?.preferences;
    if(prefs){
      this.salesPersonName= prefs.salesPersonName ?? CONSTANTS.EMPTY_STRING;
      this.salesPersonEmail= prefs.salesPersonEmail ?? CONSTANTS.EMPTY_STRING;
    }
    this.requiredFieldForm.controls.name.setValue(this.salesPersonName);
    this.requiredFieldForm.controls.email.setValue(this.salesPersonEmail);
  }
  
  get name(){
    return this.requiredFieldForm.controls.name.value?.trim();
  }
  get email(){
    return this.requiredFieldForm.controls.email.value?.trim();
  }

  onCrossClick(){
    this.dialog.open(SapSubmittalFailureComponent,{
      width: '400px',
      disableClose: true
    });

    this.dialogRef.close();
  }

  onSubmit() {
    if (this.requiredFieldForm.valid) {
      this.dialogRef.close({ name: this.name, email: this.email });
    } 

    else {
      this.dialog.open(RequiredFieldsErrorComponent, {
        width: '400px',
        disableClose: true,
      });
    }
  }
}
